/* eslint-disable react/jsx-no-target-blank */

/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import { Image, Spinner } from '@sainsburys-tech/bolt';
import { TickIcon, InsuranceIcon, InfoIcon } from '@sainsburys-tech/bolt-icons';
import { useVocab } from '@sainsburys-tech/bolt-vocab-provider';
import Button from '../../containers/Button/Button';
import Feedback from '../../containers/Feedback/Feedback';
import trackingHelper from '../../helpers/tracking';
import * as Styled from './TrolleyItem.styles';

var TrolleyItem = function TrolleyItem(_ref) {
  var _included$find;

  var partNumber = _ref.partNumber,
      quantity = _ref.quantity,
      itemType = _ref.itemType,
      subType = _ref.subType,
      showQuantity = _ref.showQuantity,
      showPrice = _ref.showPrice,
      showButton = _ref.showButton,
      moduleIndex = _ref.moduleIndex,
      productInfo = _ref.productInfo,
      trackingOptions = _ref.trackingOptions,
      onClick = _ref.onClick,
      dataTest = _ref['data-test'];

  var _useVocab = useVocab(),
      ITEM_CONTAINER = _useVocab.ITEM_CONTAINER;

  var attributes = productInfo.data.attributes,
      included = productInfo.included;
  var name = attributes.name;
  var price = (_included$find = included.find(function (item) {
    return item.type === 'prices';
  })) === null || _included$find === void 0 ? void 0 : _included$find.attributes.now;

  var onClickAddItem = function onClickAddItem() {
    var info = {
      id: partNumber,
      name: name,
      quantity: quantity,
      price: price,
      moduleIndex: moduleIndex,
      itemType: itemType,
      subType: subType
    };
    onClick(info);
  };

  var getItemImage = function getItemImage() {
    if (attributes !== null && attributes !== void 0 && attributes.isWarrantyItem) {
      return /*#__PURE__*/React.createElement(InsuranceIcon, null);
    }

    if (itemType === 'extra' && subType === 'recycling') {
      return /*#__PURE__*/React.createElement(InfoIcon, null);
    }

    return /*#__PURE__*/React.createElement(Image, {
      src: "//media.4rgos.it/s/Argos/".concat(partNumber, "_R_SET"),
      alt: "Product image",
      width: 65,
      height: 65,
      lazy: true
    });
  };

  var itemImage = getItemImage();
  trackingOptions.itemId = partNumber;
  var params = trackingHelper(trackingOptions);
  return /*#__PURE__*/React.createElement(Styled.Item, {
    itemType: itemType,
    key: "".concat(itemType, "-").concat(partNumber),
    "data-module-index": moduleIndex
  }, /*#__PURE__*/React.createElement(Styled.ItemRow, {
    className: "xs-row"
  }, /*#__PURE__*/React.createElement(Styled.Thumbnail, {
    className: "xs-3--none md-2--none"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/product/".concat(partNumber).concat(params),
    target: "_blank",
    rel: "noopener"
  }, itemImage)), /*#__PURE__*/React.createElement(Styled.Detail, {
    className: "xs-9--none md-10--none",
    "data-test": "".concat(dataTest, "-details")
  }, showQuantity && /*#__PURE__*/React.createElement(Styled.Quantity, null, /*#__PURE__*/React.createElement(TickIcon, null), quantity, " x Added"), /*#__PURE__*/React.createElement(Styled.ItemName, {
    href: "/product/".concat(partNumber).concat(params),
    target: "_blank",
    "data-product-name": true,
    rel: "noopener"
  }, name), /*#__PURE__*/React.createElement(Styled.PriceRow, {
    className: "xs-row"
  }, /*#__PURE__*/React.createElement(Styled.ItemPrice, {
    className: "xs-4--none"
  }, showPrice && /*#__PURE__*/React.createElement("span", null, "\xA3", price)), /*#__PURE__*/React.createElement("div", {
    className: "xs-8--none text-right valign-center"
  }, showButton && /*#__PURE__*/React.createElement(Button, {
    partNumber: partNumber,
    kind: "secondary",
    onClick: onClickAddItem,
    disableOnComplete: true,
    disableRecommendations: true
  }, /*#__PURE__*/React.createElement(Feedback, {
    partNumber: partNumber,
    onComplete: true
  }, /*#__PURE__*/React.createElement(TickIcon, null), " Added"), /*#__PURE__*/React.createElement(Feedback, {
    partNumber: partNumber,
    untilComplete: true
  }, "Add to ", ITEM_CONTAINER))), /*#__PURE__*/React.createElement(Feedback, {
    partNumber: partNumber,
    onLoading: true
  }, /*#__PURE__*/React.createElement(Spinner, null))))));
};

TrolleyItem.propTypes = {
  partNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  itemType: PropTypes.oneOf(['normal', 'primary', 'extra', 'warranty']),
  subType: PropTypes.string,
  moduleIndex: PropTypes.number,
  quantity: PropTypes.number,
  showQuantity: PropTypes.bool,
  showPrice: PropTypes.bool,
  showButton: PropTypes.bool,
  trackingOptions: PropTypes.shape({
    page: PropTypes.string,
    pageId: PropTypes.string,
    placement: PropTypes.string,
    innerPlacement: PropTypes.string,
    sectionTitle: PropTypes.string,
    strategy: PropTypes.string
  }),
  onClick: PropTypes.func
};
TrolleyItem.defaultProps = {
  itemType: 'normal',
  showQuantity: false,
  showPrice: true,
  showButton: true,
  trackingOptions: {},
  onClick: function onClick() {}
};
export default TrolleyItem;